import {MATH_TYPE} from 'common/report/constants';
import PropertyFilter from './../property-filter-menu/models/property-filter';
import {PropertyItem} from './../query-block/properties-menu/types';
import {ResourceType} from '../property-filter-menu/models/types'; // TODO (safdar): move this type either here or in a common dir
import {EventItem} from '../query-block/events-menu/types';
import {SerializedBehaviorDictionary} from 'common/widgets/cohorts-query-builder/models/types/serialized-cohort-types';
import {Expression} from 'common/widgets/cohorts-query-builder/models/types/expression-types';
import DateRange from '../date-range-picker/models/date-range';

export type EventFilters = PropertyFilter[];

export enum SelectorTypeDefinitions {
  EventOrUserProperty = `event_or_user_property`,
  UserProperty = `user_property`,
  Behavior = `behavior`,
  EventLaunch = `event_launch`,
}

export type SelectorType = ResourceType | SelectorTypeDefinitions;

export const SelectorTypes: SelectorType[] = [
  ResourceType.Cohort,
  ResourceType.Event,
  ResourceType.User,
  SelectorTypeDefinitions.EventOrUserProperty,
  SelectorTypeDefinitions.UserProperty,
  SelectorTypeDefinitions.Behavior,
  SelectorTypeDefinitions.EventLaunch,
];

export function isPropertySelectorType(type: SelectorType): boolean {
  return type === SelectorTypeDefinitions.EventOrUserProperty || type === SelectorTypeDefinitions.UserProperty;
}

export enum FilterOperator {
  And = `and`,
  Or = `or`,
}

export enum EventEntryPlaceholder {
  Filter = `filter`,
  Property = `property`,
}

interface SavedCohortItem {
  label: string;
  // "value" is the cohort's id
  value: number;
  data_group_id?: string;
}

interface InlineCohortItem {
  label: string;
  value: {
    cohort: {
      name: string;
      raw_cohort: {
        name: string;
        behaviors: SerializedBehaviorDictionary;
        selector: Expression;
        data_group_id?: string;
      };
    };
  };
}
export type CohortItem = SavedCohortItem | InlineCohortItem;

export function isInlineCohortItem(item: CohortItem): item is InlineCohortItem {
  return (item as InlineCohortItem).value.cohort !== undefined;
}

export interface BaseEntry {
  dataGroupId?: string;

  /** Set of filter clauses to be applied to the event */
  filters: EventFilters;

  /** Boolean operator to join filter clauses */
  filtersOperator: FilterOperator;

  /** Position of the event if this event specifies exclusion */
  excludeRange?: {from?: number; to?: number};

  /** Specifies if exclusion event range will include all collection events */
  excludeAll?: boolean;

  /** Numeric property applied on event */
  property?: PropertyItem;

  /** Specific mathematical aggregation performed on event and its properties */
  aggregationOperator?: MATH_TYPE;

  /** if set, the event index label is displayed in toggled state */
  eventIndexLabelToggled?: boolean;

  /** if set, the event value cannot be updated */
  readOnlyEvent?: boolean;

  forward?: number;
  reverse?: number;
}
export interface QueryEventEntry extends BaseEntry {
  type: ResourceType.Event;
  event: EventItem;
}
interface QueryUserEntry extends BaseEntry {
  type: ResourceType.User;
  event: EventItem;
}
export interface QueryCohortEntry extends BaseEntry {
  type: ResourceType.Cohort;
  event: CohortItem;
}

// ResourceType.Other is used for Funnels "breakdown by top paths". Maybe not relevant here.
interface QueryOtherEntry extends BaseEntry {
  type: ResourceType.Other;
  event: EventItem;
}
export interface QueryPropertyEntry extends BaseEntry {
  type: SelectorTypeDefinitions.EventOrUserProperty | SelectorTypeDefinitions.UserProperty;
  event: EventItem;
}
export interface QueryBehaviorEntry extends BaseEntry {
  type: SelectorTypeDefinitions.Behavior;
  event: EventItem;
  dateRange?: DateRange;
}
export interface QueryEventLaunch extends BaseEntry {
  type: SelectorTypeDefinitions.EventLaunch;
  event: EventItem;
  dateRange?: DateRange;
}
export type QueryEntry =
  | QueryEventEntry
  | QueryUserEntry
  | QueryCohortEntry
  | QueryOtherEntry
  | QueryPropertyEntry
  | QueryBehaviorEntry
  | QueryEventLaunch;

export function isQueryEventEntry(entry: QueryEntry): entry is QueryEventEntry {
  return entry.type === ResourceType.Event;
}
